import { Grid, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { PasskeyAuthButton } from 'shared/components';

import { messages } from './ConfirmPasskey.messages';

export const ConfirmPasskey = memo(() => {
    return (
        <Grid rowGap={16}>
            <Text font='headline' fontSize='small' fontWeight='regular'>
                {messages.title}
            </Text>

            <Text font='body' fontSize='large' fontWeight='regular'>
                {messages.description}
            </Text>

            <PasskeyAuthButton block outline noUppercase size='large' />
        </Grid>
    );
});

ConfirmPasskey.displayName = 'ConfirmPasskey';
